import { LoginForm } from "../../components";

export default function LoginPage() {
  return (
    <div className="login-page-container">
      <LoginForm />
    </div>
  );
}
